import React from 'react';
import CustomDummyDropdown from '../../../../../shared/CustomDropdown/CustomDummyDropdown';

function ServiceFilter() {
  return (
    <div className="service-filter">
      <div className="service-address">
        <div> Service address ID | 92551111245</div>
        <div style={{ marginLeft: 'auto' }}>Email joy1103@yahoo.com</div>
        <div>Address 302 TEAKWOOD DR 294889529 SC</div>
      </div>

      <div className="filter-card">
        <CustomDummyDropdown label="All Accounts" />
        <CustomDummyDropdown label="All Services" />
        <CustomDummyDropdown label="All Status" />
      </div>
    </div>
  );
}

export default ServiceFilter;
